<template>
  <div id="editor" class="panel-card certificate-editor">
    <el-form label-position="top" @submit.native.prevent="submitForm">
      <h1 class="certificate-editor__title" v-html="title"></h1>
      <input type="hidden" v-model="data.data" name="data">

      <el-form-item label="Certificate Alias Name">
        <el-input v-model="data.alias" name="alias" />
      </el-form-item>

      <el-form-item label="Serial Number (HEX)">
        <el-input :value="serial" readonly />
      </el-form-item>

      <el-form-item label="Valid Not Before">
        <el-input :value="validNotBefore" readonly />
      </el-form-item>

      <el-form-item label="Expiration Date">
        <el-input :value="validNotAfter" readonly />
      </el-form-item>

      <el-form-item label="Subject">
        <el-input :value="subject" readonly />
      </el-form-item>

      <el-form-item label="Fingerprint (SHA1)">
        <el-input :value="fingerPrint" readonly />
      </el-form-item>

      <el-form-item label="Upload Certificate">
        <el-upload action="" :auto-upload="false" :show-file-list="true" :limit="1" :on-change="handleUploadChange">
          <el-button size="small" icon="el-icon-upload2">Select certificate</el-button>
        </el-upload>
      </el-form-item>

      <div class="certificate-editor__actions">
        <el-button type="primary" native-type="submit">Ok</el-button>
        <el-button @click="cancelForm">Cancel</el-button>
        <el-button v-if="data._id !== 'new'" type="danger" @click="deleteForm">Delete</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  data:function() {
    return  {
      serial:0,
      validNotBefore: null,
      validNotAfter: null,
      fingerPrint: '',
      subject: '',
      issuerName: '',
      data: {alias:null, data:null}
    };
  },
   props: {
      model: {
          type: Promise,
          required: true
      },
      schema: {
          type: Object,
          required: true
      },
      title: {
          type: String,
          required: false
      }
  },
  watch: {
      data: function(e) {
          console.log('DATA CHANGED!',e);
          this.changedCert();
      }
  },
  mounted: function() {
      console.log(this.model);
      this.model.then((e)=>this.data=e);
  },
  methods: {
      submitForm: function(e) {
          console.log('submitForm',e);
          e.preventDefault();
          this.$emit('commit',this.data);
      },
      deleteForm: function(e) {
          console.log('submitForm',e);
          if (e && e.preventDefault) e.preventDefault();
          this.$emit('delete',this.data._id);
      },
      cancelForm: function() {
          this.$emit('revert',this.data._id);
      },
      handleUploadChange(file) {
        if (file && file.raw) {
          this.fileUpload(file.raw)
        }
      },
      fileUpload: function(oFile) {
        console.log(oFile);
        var rFilter = /\.(pem)$/i;
        if (!rFilter.test(oFile.name)) {
            this.$message.error('Error invalid file-type');
            return;
        }
        if (oFile.size == 0) {
            this.$message.error('Error unable to read file, empty?');
            return;
        }
        var oReader = new FileReader();
        var that=this;
        oReader.onload = function(e){
          console.log(e.target.result);
          var PEM = e.target.result;
          PEM=PEM.replace('-----BEGIN CERTIFICATE-----','').replace('-----END CERTIFICATE-----','');
          PEM=PEM.replace(/[^A-Za-z0-9+/=]+/gm,'');
          that.data.data = PEM;
          that.changedCert();
        }
        oReader.readAsText(oFile);
      },
      changedCert: function() {
          var cert = new X509();
          var PEM = this.data.data;
          if(this.data.data == null) {
              this.serial = '';
              this.issuerName='';
              this.validNotBefore = null;
              this.validNotAfter = null;
              this.subject = '';
              this.fingerPrint = '';
          return;
          }
          if(PEM.substr(0,4) !== '----'){
              PEM = '-----BEGIN CERTIFICATE-----\n' + PEM + '\n-----END CERTIFICATE-----';
          }
          cert.readCertPEM(PEM);
          this.serial = cert.getSerialNumberHex();
          this.issuerName=cert.getIssuerString();
          this.validNotBefore = zulutodate(cert.getNotBefore());
          this.validNotAfter = zulutodate(cert.getNotAfter());
          this.subject = cert.getSubjectString();
          this.fingerPrint = KJUR.crypto.Util.hashHex(cert.hex, 'sha1');
          console.log(cert);
      }
  }
}
</script>
<style scoped>
.certificate-editor {
  padding: 24px;
}

.certificate-editor__title {
  margin: 0 0 20px;
}

.certificate-editor__actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
</style>
